// extracted by mini-css-extract-plugin
export default {"Feed":"ContentInfiniteFeed-module__Feed__dbP_u","Cards":"ContentInfiniteFeed-module__Cards__Wengu","FullWidth":"ContentInfiniteFeed-module__FullWidth__j8gPO"};